<template>
	<div class="client-orders">
		<div class="buttons">
			<router-link to="/orders/create">
				<vs-button color="success" type="filled">
					{{ $t('create') }}
				</vs-button>
			</router-link>

			<vs-button
				color="primary"
				type="filled"
				@click="$store.dispatch('getMessages', {isClient: true})"
			>{{ $t('writeToManager') }}</vs-button>
		</div>
		<vx-card class="my-8">
			<vs-tabs>
				<vs-tab :label="`${$t('discuss')} (${orders.discussed.length})`">
					<div class="tab-text">
						<vs-table max-items="10" pagination :data="orders.discussed">
							<template slot="thead">
								<vs-th sort-key="created">
									{{ $t('creationDate') }}
								</vs-th>
								<vs-th sort-key="name">
									{{ $t('topic') }}
								</vs-th>
								<vs-th>
								</vs-th>
								<vs-th sort-key="author">
									{{ $t('author') }}
								</vs-th>
								<vs-th sort-key="subject">
									{{ $t('subject') }}
								</vs-th>
								<vs-th sort-key="work_type">
									{{ $t('type') }}
								</vs-th>
								<vs-th sort-key="quality_level">
									{{ $t('level') }}
								</vs-th>
								<vs-th sort-key="pages_number">
									{{ $t('pagesCount') }}
								</vs-th>
								<vs-th sort-key="language">
									{{ $t('language') }}
								</vs-th>
								<vs-th sort-key="due_date">
									{{ $t('dueDate') }}
								</vs-th>
							</template>

							<template slot-scope="{data}">
								<vs-tr :key="indextr" v-for="(tr, indextr) in data">
									<vs-td :data="data[indextr].created">
										{{ data[indextr].created }}
									</vs-td>
									<vs-td :data="data[indextr].name">
										<router-link :to="'order/'+data[indextr].id">{{
												data[indextr].name
											}}
										</router-link>
									</vs-td>
									<vs-td :data="data[indextr].chat_messages_count">
										<span class="counter" :class="{warn:  data[indextr].is_chat_unread}">
											{{ data[indextr].chat_messages_count }}
										</span>
									</vs-td>
									<vs-td :data="data[indextr].author">
										{{ data[indextr].author }}
									</vs-td>
									<vs-td :data="data[indextr].subject">
										{{$getDeep(data[indextr].subject,subjects)}}
									</vs-td>
									<vs-td :data="data[indextr].work_type">
										{{$getDeep(data[indextr].work_type,works)}}
									</vs-td>
									<vs-td :data="data[indextr].quality_level">
										{{$getDeep(data[indextr].quality_level,levels)}}
									</vs-td>
									<vs-td :data="data[indextr].pages_number">
										{{ data[indextr].pages_number }}
									</vs-td>
									<vs-td :data="data[indextr].language">
										{{$getDeep(data[indextr].language,languages)}}
									</vs-td>
									<vs-td :data="data[indextr].due_date">
										{{ data[indextr].due_date }}
									</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</div>
				</vs-tab>
				<vs-tab :label="`${$t('inProgress')} (${orders.inProcess.length})`">
					<div class="tab-text">
						<vs-table max-items="10" pagination :data="orders.inProcess">
							<template slot="thead">
								<vs-th sort-key="created">
									{{ $t('creationDate') }}
								</vs-th>
								<vs-th sort-key="name">
									{{ $t('topic') }}
								</vs-th>
								<vs-th>
								</vs-th>
								<vs-th sort-key="author">
									{{ $t('author') }}
								</vs-th>
								<vs-th sort-key="subject">
									{{ $t('subject') }}
								</vs-th>
								<vs-th sort-key="work_type">
									{{ $t('type') }}
								</vs-th>
								<vs-th sort-key="quality_level">
									{{ $t('level') }}
								</vs-th>
								<vs-th sort-key="pages_number">
									{{ $t('pagesCount') }}
								</vs-th>
								<vs-th sort-key="language">
									{{ $t('language') }}
								</vs-th>
								<vs-th sort-key="due_date">
									{{ $t('dueDate') }}
								</vs-th>
							</template>

							<template slot-scope="{data}">
								<vs-tr :key="indextr" v-for="(tr, indextr) in data">
									<vs-td :data="data[indextr].created">
										{{ data[indextr].created }}
									</vs-td>
									<vs-td :data="data[indextr].name">
										<router-link :to="'order/'+data[indextr].id">{{
												data[indextr].name
											}}
										</router-link>
									</vs-td>
									<vs-td :data="data[indextr].chat_messages_count">
										<span class="counter" :class="{warn:  data[indextr].is_chat_unread}">
											{{ data[indextr].chat_messages_count }}
										</span>
									</vs-td>
									<vs-td :data="data[indextr].author">
										{{ data[indextr].author }}
									</vs-td>
									<vs-td :data="data[indextr].subject">
										{{$getDeep(data[indextr].subject,subjects)}}
									</vs-td>
									<vs-td :data="data[indextr].work_type">
										{{$getDeep(data[indextr].work_type,works)}}
									</vs-td>
									<vs-td :data="data[indextr].quality_level">
										{{$getDeep(data[indextr].quality_level,levels)}}
									</vs-td>
									<vs-td :data="data[indextr].pages_number">
										{{ data[indextr].pages_number }}
									</vs-td>
									<vs-td :data="data[indextr].language">
										{{$getDeep(data[indextr].language,languages)}}
									</vs-td>
									<vs-td :data="data[indextr].due_date">
										{{ data[indextr].due_date }}
									</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</div>
				</vs-tab>
				<vs-tab :label="`${$t('done')} (${orders.done.length})`">
					<div class="tab-text">
						<vs-table max-items="10" pagination :data="orders.done">
							<template slot="thead">
								<vs-th sort-key="created">
									{{ $t('creationDate') }}
								</vs-th>
								<vs-th sort-key="name">
									{{ $t('topic') }}
								</vs-th>
								<vs-th>
								</vs-th>
								<vs-th sort-key="author">
									{{ $t('author') }}
								</vs-th>
								<vs-th sort-key="subject">
									{{ $t('subject') }}
								</vs-th>
								<vs-th sort-key="work_type">
									{{ $t('type') }}
								</vs-th>
								<vs-th sort-key="quality_level">
									{{ $t('level') }}
								</vs-th>
								<vs-th sort-key="pages_number">
									{{ $t('pagesCount') }}
								</vs-th>
								<vs-th sort-key="language">
									{{ $t('language') }}
								</vs-th>
								<vs-th sort-key="due_date">
									{{ $t('dueDate') }}
								</vs-th>
							</template>

							<template slot-scope="{data}">
								<vs-tr :key="indextr" v-for="(tr, indextr) in data">
									<vs-td :data="data[indextr].created">
										{{ data[indextr].created }}
									</vs-td>
									<vs-td :data="data[indextr].name">
										<router-link :to="'order/'+data[indextr].id">{{
												data[indextr].name
											}}
										</router-link>
									</vs-td>
									<vs-td :data="data[indextr].chat_messages_count">
										<span class="counter" :class="{warn:  data[indextr].is_chat_unread}">
											{{ data[indextr].chat_messages_count }}
										</span>
									</vs-td>
									<vs-td :data="data[indextr].author">
										{{ data[indextr].author }}
									</vs-td>
									<vs-td :data="data[indextr].subject">
										{{$getDeep(data[indextr].subject,subjects)}}
									</vs-td>
									<vs-td :data="data[indextr].work_type">
										{{$getDeep(data[indextr].work_type,works)}}
									</vs-td>
									<vs-td :data="data[indextr].quality_level">
										{{$getDeep(data[indextr].quality_level,levels)}}
									</vs-td>
									<vs-td :data="data[indextr].pages_number">
										{{ data[indextr].pages_number }}
									</vs-td>
									<vs-td :data="data[indextr].language">
										{{$getDeep(data[indextr].language,languages)}}
									</vs-td>
									<vs-td :data="data[indextr].due_date">
										{{ data[indextr].due_date }}
									</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</div>
				</vs-tab>
			</vs-tabs>
		</vx-card>

	</div>
</template>

<script>

export default {
	name: "Orders",
	data() {
		return {
			orders: {
				discussed: [],
				inProcess: [],
				done: [],
			},
			levels: [],
			languages: [],
			works: [],
			subjects: [],
		}
	},
	async mounted () {
		const role = this.$store.state.auth.role;
		if(role !== "client") return await this.$router.push("/tickets");

		this.levels = (await this.$http.get('/settings/get-quality-levels')).data.data;
		this.languages = (await this.$http.get('/settings/get-languages')).data.data;
		this.works = (await this.$http.get('/settings/get-work-types')).data.data;
		this.subjects = (await this.$http.get('/settings/get-subjects')).data.data;

		this.orders.discussed = (await this.$http.get('/client/order?tab=discussion')).data.data;
		this.orders.inProcess = (await this.$http.get('/client/order?tab=in_progress')).data.data;
		this.orders.done = (await this.$http.get('/client/order?tab=completed')).data.data;

		for(let tab of ["discussed", "inProcess", "done"]) {
			this.orders[tab].forEach(item => {
				if(item.author === null) {
					item.author = "---"
					return;
				}
				item.author.toString = () => { console.log(item.author.username); return item.author.username; };
			});
		}
	},
}
</script>

<style lang="scss">
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}

.fade-enter, .fade-leave-to
{
	opacity: 0;
}

.buttons {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	@media screen and (max-width: 375px) {
		button {
			margin: 5px 0;
		}
	}
}

.vs-tabs--content {
	padding: 0;
	margin-top: 10px;
}

.vs-con-table .vs-con-tbody {
	border: 0;
	background-color: transparent;

}

.vs-table {
	margin-top: 10px;

	tr {
		border-top: 1px solid #cfcfcf;

		&:last-child {
			border-bottom: 1px solid #cfcfcf;
		}
	}
}

.counter {

	padding: 5px;
	border-radius: 100%;
	font-weight: 600;
	font-size: 0.7rem;
	border: 1px solid #cfcfcf;
	width: 21px;
	height: 21px;
	display: flex;
	align-items: center;
	line-height: 1;
	justify-content: center;
	&.warn {
		background-color: #f0ad4e;
		color: white;
		border-color: #f0ad4e;
	}

}

.client-orders {
	.vs-table-text{
		cursor: pointer;
		user-select: none;
	}
}
</style>
